export default {
  'ledger.caller.canvas-prompt-optimize': '优化提示词',
  'ledger.title': '消费记录',
  'ledger.time': '时间',
  'ledger.user': '用户',
  'ledger.caller': '任务类型',
  'ledger.refId': '任务 ID',
  'ledger.amount': '扣费',
  'ledger.balance': '余额',
  'ledger.empty': '暂无消费记录',
  'ledger.filterCaller': '任务类型',
  'ledger.filterDate': '时间区间',
  'ledger.filterUser': '用户搜索',
  'ledger.reset': '重置',
  'ledger.total': '共 {n} 条',

  'ledger.topup.title': '充值记录',
  'ledger.topup.orderNo': '订单号',
  'ledger.topup.amount': '金额',
  'ledger.topup.manual': '手动',
  'ledger.topup.credits': '到账 Credits',
  'ledger.topup.status': '状态',
  'ledger.topup.paidAt': '支付时间',
  'ledger.topup.empty': '暂无充值记录',
  'ledger.topup.status.pending': '待支付',
  'ledger.topup.status.paid': '已支付',
  'ledger.topup.status.refunded': '已退款',
  'ledger.topup.status.failed': '失败',
  'ledger.topup.status.expired': '已过期',
  'ledger.topup.source.custom': '自定义',
  'ledger.topup.source.pack': '优惠包',

  // caller 文案 — 与 dashboard `billing.caller.*` 同源,运营改动同步双边
  'ledger.caller.canvas-image': '画布生图',
  'ledger.caller.canvas_image': '画布生图',
  'ledger.caller.canvas_image_freegen': '画布生图',
  'ledger.caller.canvas_image_relight': '画布打光',
  'ledger.caller.canvas_image_multi_view': '画布多视角',
  'ledger.caller.canvas_image_inpaint': '画布选区重画',
  'ledger.caller.canvas_image_outpaint': '画布扩图',
  'ledger.caller.canvas_image_matting': '画布抠图',
  'ledger.caller.canvas_image_hd': '画布高清',
  'ledger.caller.canvas_image_panorama': '画布全景',
  'ledger.caller.canvas_image_sheet': '宫格生片',
  'ledger.caller.canvas_image_sheet_shot_grid': '宫格·多机位九宫格',
  'ledger.caller.canvas_image_sheet_expression': '宫格·表情九宫格',
  'ledger.caller.canvas_image_sheet_action_pose': '宫格·动作姿态',
  'ledger.caller.canvas_image_sheet_outfit': '宫格·服装变体',
  'ledger.caller.canvas_image_sheet_lighting': '宫格·光线氛围',
  'ledger.caller.canvas_image_sheet_hand_detail': '宫格·手部特写',
  'ledger.caller.canvas-video': '画布生视频',
  'ledger.caller.canvas_video': '画布生视频',
  'ledger.caller.canvas_video_freegen': '画布生视频',
  'ledger.caller.canvas-audio': '画布生音频',
  'ledger.caller.canvas_audio': '画布生音频',
  'ledger.caller.canvas_audio_freegen': '画布生音频',
  'ledger.caller.character_canonical': '角色主图',
  'ledger.caller.character_shot': '角色镜头',
  'ledger.caller.character_sheet': '角色 Sheet',
  'ledger.caller.scene_canonical': '场景主图',
  'ledger.caller.scene_sheet': '场景 Sheet',
  'ledger.caller.scene_sheet_kind': '场景 Sheet',
  'ledger.caller.scene_extra_view': '场景补镜头',
  'ledger.caller.scene_panorama': '场景全景',
  'ledger.caller.project_cover': '项目封面',
  'ledger.caller.storyboard_frame': '分镜帧',
  'ledger.caller.storyboard_video': '分镜视频',
  'ledger.caller.storyboard_audio': '分镜配音',
  'ledger.caller.project-parse': '项目解析',
  'ledger.caller.parse-detect-marker': '项目分集识别',
  'ledger.caller.parse-infer-meta': '项目信息推断',
  'ledger.caller.parse-scene-boundaries': '场景切分',
  'ledger.caller.parse-normalize-scene': '场景规整',
  'ledger.caller.gen-character-prompts': '角色 Prompt',
  'ledger.caller.video-prompt': '视频 Prompt',
  'ledger.caller.agent-chat': 'Agent 对话',
  'ledger.caller.learn-parse-dsl': '项目格式学习',
  'ledger.caller.extract-characters': '角色抽取',
  'ledger.caller.extract-scenes': '场景抽取',
  'ledger.caller.enrich-project': '项目丰富',
  'ledger.caller.character-prompts': '角色 Prompt',
  'ledger.caller.character-sheet-cells': '角色 Sheet Cell',
  'ledger.caller.scene-sheet-cells': '场景 Sheet Cell',
  'ledger.caller.storyboard': '分镜生成',
  'ledger.caller.storyboard-gen': '分镜生成',
  'ledger.caller.storyboard-shot-regenerate': '单镜头重生',
  'ledger.caller.storyboard-frame-prompt': '分镜帧 Prompt',
  'ledger.caller.storyboard-video-prompt': '视频 Prompt',
  'ledger.caller.reverse-prompt-image': '图片反推',
  'ledger.caller.reverse-prompt-video': '视频反推',
  'ledger.caller.canvas-text-rewrite': '文本改写',
  'ledger.caller.novel-adapt': '小说改编',
  'ledger.caller.oral-generate': '口播稿',
  'ledger.caller.canonicalize-scenes': '场景去重',
  'ledger.caller.skill-compile': 'Skill 编译',
  'ledger.caller.credit-quote': '价格预估',
  'ledger.caller.admin-test': '管理员试跑',
  'ledger.caller.agent-im': 'Agent 对话',
};
